import React from 'react'

import { Box, Col, Grid, Heading5, Space } from '@gousto-internal/citrus-react'

import { LoadingSkeleton } from './LoadingSkeleton'

const CATEGORY_COUNT = 4

const CategoryGridSkeleton = () => (
  <>
    <Heading5>Popular Categories</Heading5>
    <Space size={4} />
    <Grid gap={[3, null, 4]}>
      {Array.from({ length: CATEGORY_COUNT }, (_, index) => (
        <Col key={index} size={[6, null, 4]}>
          <Box paddingV={2}>
            <LoadingSkeleton style={{ display: 'block', height: '65px', width: '100%' }} />
            <Box paddingV={2}>
              <LoadingSkeleton style={{ display: 'block', height: '20px', width: '75%' }} />
            </Box>
          </Box>
        </Col>
      ))}
    </Grid>
  </>
)

export const MenuExperienceSearchLandingSkeleton = () => <CategoryGridSkeleton />
